import React, { Component } from 'react';
import { Row, Label, Col, Button, Card, CardBody, Input, Form, CardTitle, Progress, FormGroup } from 'reactstrap';
import logo from "../imgs/KLLogo2.png";
import MensajeModal from "../components/MensajeModal"
import TabAyudaAgente from "../components/TabAyudaAgente"
import { connect } from 'react-redux';
import { logout } from '../actions/index';
import { bindActionCreators } from 'redux';
import axios from "axios";
import { OBTENER_URL_SERVICIO } from "../constants/action-types";
import Timer from "react-time-counter";

const mapStateToProps = state => {
    return { agente: state.agente };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ logout }, dispatch)
    };
};


class HeaderComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            activeTab: '1',
            estadoModulo: "Activo",
            suspenderBase: {
                idSuspensionBase: "",
                tiempoSuspensionBase: "",
            },
        };
        this.toggleTab = this.toggleTab.bind(this);
        this.toggle = this.toggle.bind(this);
        this.modalAyuda = this.modalAyuda.bind(this);
        this.cerrarSesion = this.cerrarSesion.bind(this);
        this.cambiarEstado = this.cambiarEstado.bind(this);
        this.pedirConfirmacionEstado = this.pedirConfirmacionEstado.bind(this);
        this.activarSuspendido = this.activarSuspendido.bind(this);
        this.handleSelectSuspension = this.handleSelectSuspension.bind(this);
    }

    async cerrarSesion() {
        /*if (window.gapi) {
          const auth2 = window.gapi.auth2.getAuthInstance()
          if (auth2 != null) {
            auth2.signOut().then(
              auth2.disconnect().then(this.props.onLogoutSuccess)
            )
          }
        }
        this.forceUpdate()
        this.setState({ validacion: false })
      }
    
      componentWillUnmount() {
        if (this.state.validacion === false) {
          this.props.logout()
        }*/
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/cambiarEstadoAgente/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/2");
            if (response.data.tipo === "EXITO") {
                this.setState({
                    estadoModulo: "Cerrado",
                })
                this.props.logout();
            }
            else {
                this.setState({
                    modalTitulo: "Oops!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Algo salió mal, intenta de nuevo por favor. (200 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div>
                        <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                    </div>,
                })
            }
        } catch (error) {

            this.setState({
                modalTitulo: "Oops!",
                modalMensaje:
                    <div>
                        <center>
                            <p>Algo salió mal, intenta de nuevo por favor. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div>
                    <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                </div>,
            })
        }
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    handleSelectSuspension(event) {
        var suspenderBase = this.state.suspenderBase;
        var res = event.target.value.split("///");
        suspenderBase.idSuspensionBase = res[0];
        suspenderBase.tiempoSuspensionBase = res[1];
        this.setState({
            suspenderBase: suspenderBase,
        })
    }


    modalAyuda() {
        this.setState({
            modalTitulo: "Ayuda",
            modalMensaje:
                <div>
                    <p>Esta es la página para los Agentes que atenderán los servicios solicitados por los usuarios del Sistema de Gestión de Turnos.</p>
                    <p>Selecciona una opción de ayuda:</p>
                    <p></p>
                    <Card body>
                        <TabAyudaAgente></TabAyudaAgente>
                    </Card>

                    <p></p>
                    <p>Si no encuentras la ayuda que buscabas, tienes problemaso alguna queja, comunicate al:</p>
                    <p>(+57-1) 347 2311 ext. 186 (Departamento de TI)</p>
                </div>,
            modalFooter: <Button onClick={this.toggle}> Cerrar</Button>
        })
        this.toggle();
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async pedirConfirmacionEstado(event) {
        if (event.target.id === "Activo") {
            this.setState({
                modalTitulo: "Cambiar estado a activo!",
                modalMensaje:
                    <div>
                        <center>
                            <p>¿Deseas confirmar el cambio de tu módulo a "Activo"?</p>
                            <p>Empezarás a recibir solicitudes de turnos por parte de los usuarios.</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Button color="success" id="Activo" onClick={this.cambiarEstado}>Confirmar</Button>
                        <br /><br />
                        <Button color="danger" onClick={this.toggle}>Cancelar</Button>
                    </center>
                </div>,
            })
            this.toggle();
        }
        else {
            if (event.target.id === "Cerrado") {
                this.setState({
                    modalTitulo: "Cambiar estado a activo!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>¿Deseas confirmar el cambio de tu módulo a "Cerrado"?</p>
                                <p>Todos los turnos de tu cola serán eliminados y no recibirás más turnos.</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Button color="success" id="Cerrado" onClick={this.cambiarEstado}>Confirmar</Button>
                            <br /><br />
                            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
                        </center>
                    </div>,
                })
                this.toggle();
            }
            else {
                if (event.target.id === "Suspendido") {
                    try {
                        this.setState({
                            modalTitulo: "Espera por favor",
                            modalMensaje:
                                <div>
                                    <center>
                                        <p>¡Estamos buscando los tiempos de suspensión de módulo permitidos!</p>
                                    </center>
                                </div>,
                            modalFooter: <div style={{ width: "100%" }}>
                                <Progress animated color="success" value="100" />
                            </div>,
                        })
                        this.toggle();
                        const response = await axios.get(OBTENER_URL_SERVICIO + "/obtenerEstados");
                        if (response.data.length <= 0) {
                            this.setState({
                                modalTitulo: "Error",
                                modalMensaje:
                                    <div>
                                        <center>
                                            <p>En el momento no hay algún tipo de suspensión de módulo permitida.</p>
                                            <p>Por favor intenta de nuevo más tarde o acércate al Departamento de TICs de la Universidad.</p>
                                        </center>
                                    </div>,
                                modalFooter: < div >
                                    <Button onClick={this.toggle}> Aceptar</Button>
                                </div >,
                            })
                        } else {
                            const idSuspensionBase = response.data[0].secEstado;
                            const tiempoSuspensionBase = response.data[0].tiempoMaximoMinutos;
                            var suspenderBase = this.state.suspenderBase;
                            suspenderBase.idSuspensionBase = idSuspensionBase;
                            suspenderBase.tiempoSuspensionBase = tiempoSuspensionBase;
                            this.setState({
                                suspenderBase: suspenderBase,
                            })
                            var opcionesSuspension = response.data.map(p => {
                                return (<option key={p.secEstado} value={p.secEstado + "///" + p.tiempoMaximoMinutos} id={p.tiempoMaximoMinutos}>{p.namEstado + " : " + p.tiempoMaximoMinutos + " minutos"} </option>)
                            });
                            this.setState({
                                modalTitulo: "Cambiar estado a Suspendido",
                                modalMensaje:
                                    <div>
                                        <center>
                                            <FormGroup>
                                                <Label for="exampleSelect">¿Deseas confirmar el cambio de tu módulo a "Suspendido"?</Label>
                                                <Label> Selecciona el tiempo y tipo de suspensión deseado:</Label>
                                                <Input onChange={this.handleSelectSuspension} type="select" name="select">
                                                    {opcionesSuspension}
                                                </Input>
                                                <Label> Empezarás a recibir solicitudes de turnos por parte de los usuarios.</Label>
                                            </FormGroup>
                                        </center>
                                    </div>,
                                modalFooter: <div>
                                    <Button color="success" id="Suspendido" onClick={this.cambiarEstado}>Confirmar</Button>{' '}
                                    <Button onClick={this.toggle} color="danger"> Cancelar</Button>
                                </div>,
                            })
                        }
                    } catch (error) {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <center>
                                        <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde.</p>
                                        <p>Puede que no hayan tipos de suspensión habilitadas en el momento.</p>
                                    </center>
                                </div>,
                            modalFooter: <div style={{ width: "100%" }}>
                                <center>
                                    <Label><Timer seconds={10} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                                </center>
                            </div>,
                        })
                        setTimeout(
                            function () {
                                this.toggle();
                            }
                                .bind(this),
                            5000
                        );

                    }
                }
                else {
                    this.setState({
                        modalTitulo: "Oops!",
                        modalMensaje:
                            <div>
                                <center>
                                    <p>Algo salió mal, intenta de nuevo por favor.</p>
                                </center>
                            </div>,
                        modalFooter: <div>
                            <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                        </div>,
                    })
                    this.toggle();
                }
            }
        }
    }

    async cambiarEstado(event) {
        if (event.target.id === "Activo") {
            try {
                const response = await axios.get(OBTENER_URL_SERVICIO + "/cambiarEstadoAgente/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/1");
                if (response.data.tipo === "EXITO") {
                    this.setState({
                        estadoModulo: "Activo",
                    })
                    this.toggle();
                }
                else {
                    this.setState({
                        modalTitulo: "Oops!",
                        modalMensaje:
                            <div>
                                <center>
                                    <p>Algo salió mal, intenta de nuevo por favor. (200 Error)</p>
                                </center>
                            </div>,
                        modalFooter: <div>
                            <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                        </div>,
                    })
                }
            } catch (error) {
                this.setState({
                    modalTitulo: "Oops!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Algo salió mal, intenta de nuevo por favor. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div>
                        <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                    </div>,
                })
            }
        }
        else {
            if (event.target.id === "Cerrado") {
                try {
                    const response = await axios.get(OBTENER_URL_SERVICIO + "/cambiarEstadoAgente/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/2");
                    if (response.data.tipo === "EXITO") {
                        this.setState({
                            estadoModulo: "Cerrado",
                        })
                        this.toggle();
                    }
                    else {
                        this.setState({
                            modalTitulo: "Oops!",
                            modalMensaje:
                                <div>
                                    <center>
                                        <p>Algo salió mal, intenta de nuevo por favor. (200 Error)</p>
                                    </center>
                                </div>,
                            modalFooter: <div>
                                <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                            </div>,
                        })
                    }
                } catch (error) {

                    this.setState({
                        modalTitulo: "Oops!",
                        modalMensaje:
                            <div>
                                <center>
                                    <p>Algo salió mal, intenta de nuevo por favor. (500 Error)</p>
                                </center>
                            </div>,
                        modalFooter: <div>
                            <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                        </div>,
                    })
                }
            }
            else {
                if (event.target.id === "Suspendido") {

                    try {
                        const response = await axios.get(OBTENER_URL_SERVICIO + "/cambiarEstadoAgente/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/3");
                        if (response.data.tipo === "EXITO") {
                            this.setState({
                                estadoModulo: "Suspendido",
                                modalTitulo: "Modulo Suspendido",
                                modalMensaje:
                                    <div>
                                        <center>
                                            <p>El módulo estará suspendido durante</p>
                                            <Timer minutes={Number(this.state.suspenderBase.tiempoSuspensionBase)} backward={true} callback={this.activarSuspendido} />
                                            <p>Si cierras el navegador y vuelves a ingresar al sistema, el módulo será activado de nuevo.</p>
                                            <p>¿Deseas reactivar el módulo manualmente?</p>
                                        </center>
                                    </div>,
                                modalFooter: <div style={{ width: "100%" }}>
                                    <center>
                                        <Button color="warning" onClick={this.activarSuspendido}>Activar</Button>
                                    </center>
                                </div>,
                            })
                        }
                        else {
                            this.setState({
                                modalTitulo: "Oops!",
                                modalMensaje:
                                    <div>
                                        <center>
                                            <p>Algo salió mal, intenta de nuevo por favor. (200 Error)</p>
                                        </center>
                                    </div>,
                                modalFooter: <div>
                                    <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                                </div>,
                            })
                        }
                    } catch (error) {

                        this.setState({
                            modalTitulo: "Oops!",
                            modalMensaje:
                                <div>
                                    <center>
                                        <p>Algo salió mal, intenta de nuevo por favor. (500 Error)</p>
                                    </center>
                                </div>,
                            modalFooter: <div>
                                <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                            </div>,
                        })
                    }
                }
                else {

                }
            }
        }
    }

    async activarSuspendido() {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/cambiarEstadoAgente/" + this.props.agente.areaAgente + "/" + this.props.agente.identificacionAgente + "/1");
            if (response.data.tipo === "EXITO") {
                this.setState({
                    estadoModulo: "Activo",
                })
                this.toggle();
            }
            else {
                this.setState({
                    modalTitulo: "Oops!",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Algo salió mal, intenta de nuevo por favor. (200 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div>
                        <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                    </div>,
                })
                this.toggle();
            }
        } catch (error) {

            this.setState({
                modalTitulo: "Oops!",
                modalMensaje:
                    <div>
                        <center>
                            <p>Algo salió mal, intenta de nuevo por favor. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div>
                    <Button color="danger" onClick={this.toggle}>Aceptar</Button>{' '}
                </div>,
            })
            this.toggle();
        }
    }

    render() {
        var botonesEstado;
        var labelEstado;
        if (this.props.agenteOcupado === true) {
            labelEstado = <Label style={{ marginTop: "5px" }} for="estadoModuloLabel">Estado actual del módulo: Módulo Activo</Label>;
            botonesEstado = <Row>
                <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                    <Button style={{ width: "100%" }} id="Suspendido" disabled outline color="warning">Suspender</Button>
                </Col>
                <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                    <Button style={{ width: "100%" }} id="Activo" disabled color="success">Activar</Button>
                </Col>
            </Row>
        } else {
            if (this.state.estadoModulo === "Cerrado") {
                labelEstado = <Label style={{ marginTop: "5px" }} for="estadoModuloLabel">Estado actual del módulo: Módulo Cerrado</Label>;
                botonesEstado = <Row>
                    <Col md={{ size: 4 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                        <Button style={{ width: "100%" }} id="Cerrado" disabled color="danger">Cerrar</Button>
                    </Col>
                    <Col md={{ size: 4 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                        <Button style={{ width: "100%" }} onClick={this.pedirConfirmacionEstado} id="Suspendido" outline color="warning">Suspender</Button>
                    </Col>
                    <Col md={{ size: 4 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                        <Button style={{ width: "100%" }} onClick={this.pedirConfirmacionEstado} id="Activo" outline color="success">Activar</Button>
                    </Col>
                </Row>
            }
            else {
                if (this.state.estadoModulo === "Activo") {
                    labelEstado = <Label style={{ marginTop: "5px" }} for="estadoModuloLabel">Estado actual del módulo: Módulo Activo</Label>;
                    botonesEstado = <Row>
                        <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                            <Button style={{ width: "100%" }} onClick={this.pedirConfirmacionEstado} id="Suspendido" outline color="warning">Suspender</Button>
                        </Col>
                        <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                            <Button style={{ width: "100%" }} id="Activo" disabled color="success">Activar</Button>
                        </Col>
                    </Row>
                }
                else {
                    if (this.state.estadoModulo === "Suspendido") {
                        labelEstado = <Label style={{ marginTop: "5px" }} for="estadoModuloLabel">Estado actual del módulo: Módulo Suspendido</Label>;
                        botonesEstado = <Row>
                            <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                                <Button style={{ width: "100%" }} id="Suspendido" disabled color="warning">Suspender</Button>
                            </Col>
                            <Col md={{ size: 6 }} sm={{ size: 12 }} xs={{ size: 12 }}>
                                <Button style={{ width: "100%" }} onClick={this.pedirConfirmacionEstado} id="Activo" outline color="success">Activar</Button>
                            </Col>
                        </Row>
                    }
                    else {
                        
                    }
                }
            }
        }


        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <br />
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col xl={{ size: 2 }} lg={{ size: 3 }} md={{ size: 3 }} sm={{ size: 12 }}>
                                        <center>
                                            <Row>
                                                <Col xs={{ size: 12 }}>
                                                    <img style={{ verticalAlign: "middle" }} height="100%" src={logo} alt="logo" />
                                                </Col>
                                                <Col xs={{ size: 12 }}>
                                                    <CardTitle style={{ marginBottom: "0px" }}>Sistema de gestión de turnos</CardTitle>
                                                </Col>
                                            </Row>
                                        </center>
                                    </Col>
                                    <Col xl={{ size: 9 }} lg={{ size: 7 }} md={{ size: 7 }} sm={{ size: 12 }}>
                                        <Form inline>
                                            <Col md={{ size: 6 }} xs={{ size: 12 }}>
                                                <Input style={{ width: "100%" }} type="email" name="email" id="exampleEmail" disabled={true} value={this.props.agente.nombreAgente + " " + this.props.agente.apellidoAgente} />
                                            </Col>
                                            <Col md={{ size: 6 }} xs={{ size: 12 }}>
                                                <Input style={{ width: "100%" }} type="email" name="email" id="exampleEmail" disabled={true} value={this.props.agente.correoAgente} />
                                            </Col>
                                        </Form>
                                        <center>
                                            {labelEstado}
                                        </center>
                                        {botonesEstado}
                                    </Col>
                                    <Col xl={{ size: 1 }} lg={{ size: 2 }} md={{ size: 2 }} sm={{ size: 12 }}>
                                        <center>
                                            <p />
                                            <Button color="info" onClick={this.modalAyuda}>Ayuda</Button>
                                            <br />
                                            <Button color="danger" onClick={this.cerrarSesion} style={{ marginTop: "5px" }}>Logout</Button>
                                        </center>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <br />
            </div>
        );
    }


}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComp);
